import React  from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import { Grid } from '@mui/material';
import ListHoursAvailables from './ListHoursAvailables';
import InformationProfessional from 'src/Professional/InformationProfessional';
import ProfessionalPhoto from 'src/Professional/ProfessionalPhoto';
import { cardBase, cardHeader } from 'src/shared/styles/cardStyles';

export default function CardProfessional({ professional }) {
    return (
        <Card sx={{ ...cardBase }}>
            <CardHeader
                style={{ ...cardHeader , backgroundColor: professional?.horas[0].ageInicio == '00:00' ? '#005398' : '#288FF9'}}
                // title={<div style={{ fontSize: 12, }}><strong>Particular: </strong> {professional.valorParticular?.replace(",", ".") || 'no disponible'}</div>}
                title={<div style={{ fontSize: 12, display: 'flex', justifyContent: 'space-between' }}> <div><strong>Particular: </strong> {professional.valorParticular?.replace(",", ".") || 'no disponible'}</div> 
                
                {professional.ptdRut.trim() == '63291692' ? <div><small><strong style={{fontSize: 14, letterSpacing: 0.5,  textShadow: '1px 1px 1px #666666'}}>TELEMEDICINA</strong></small></div> : null}

               {process.env.REACT_APP_SEDE == 'Chillán' || process.env.REACT_APP_SEDE == 'Calama' ? (<></>) : (<div><small>Sucursal: </small><strong style={{textShadow: '1px 1px 1px #666666'}}>{professional.sede}</strong></div>)
                }                
                </div>
                }
            />
            <CardContent style={{ backgroundColor:   '#F9FAFB' }}>
                <Grid style={{ display: "flex", alignItems: "center" }}>
                    <ProfessionalPhoto image={professional.imagen} alt={professional.ptdNombre} rut={professional.ptdRut} />
                    <Grid item style={{ marginLeft: 12, }}>
                        <InformationProfessional professional={professional} />
                    </Grid>
                </Grid>
            </CardContent>
            <CardActions style={{ padding: "8px 12px" }}>
                <ListHoursAvailables professional={professional} hours={professional?.horas} />
            </CardActions>
        </Card>
    );
}